import { render, staticRenderFns } from "./DetailUssd.vue?vue&type=template&id=ed4b97f8&scoped=true&"
import script from "./DetailUssd.vue?vue&type=script&lang=js&"
export * from "./DetailUssd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4b97f8",
  null
  
)

export default component.exports